module.exports = __webpack_public_path__ + "media/customizations/regencyatsrr/logo-new-990edfb457352bcd3fc75c06b5f3f7f0.png";